import loadProductModule from './modules/Product.module';
import loadProductDetailDynamicModule from './modules/ProductDetail.module';
import loadProductContentVideoModule from './modules/ProductContentVideo.module';
import loadCustomerModule from './modules/Customer.module';
import loadMonetateModule from './modules/Monetate.module';
const loadProductDetailModule = initialData => ({
    hasRouter: true,
    modules: [
        loadProductModule(initialData),
        loadProductDetailDynamicModule(),
        loadProductContentVideoModule(),
        loadCustomerModule(),
        loadMonetateModule(),
    ],
});
export default loadProductDetailModule;
